import { render, staticRenderFns } from "./BudgetAllocationChart.vue?vue&type=template&id=b504a95c"
import script from "./BudgetAllocationChart.vue?vue&type=script&lang=js"
export * from "./BudgetAllocationChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports